// there is a backend Enum that needs to match this
import {ModelType} from '~/enums/modelType'
import {GenericType} from '~/interfaces/genericTypeInterfaces'

export enum ReferenceNodeType {
  // User Types
  OriginalSubmitter = 1001,
  RecordHolder = 1002,
  AllCompleters = 1003,
  StepCompleter = 1004,
  // Document Date Types
  FormSubmissionDate = 1101,
  FormSubmissionID = 1102,
  // Form Types
  Form = 2001,
  FormElement = 2002,
  WorkflowStep = 2003,
  WorkflowStepAction = 2004,
  FormSection = 2005,
  // Form Step Data Types
  FormPaymentsTotalCost = 2101,
  FormPaymentsType = 2102,
  FormPaymentsDate = 2103,
  FormPaymentsLineItem = 2104,
  WorkflowStepStart = 2105,
  WorkflowStepEnd = 2106,
  WorkflowGeneratedCert = 2107,
  // Object Model Types
  ObjectModel = 3001,
  ObjectModelProperty = 3002,
  ObjectModelRelation = 3003,
  ObjectModelRecordMetadata = 3004,
  AccountRelationMetadata = 3005,
  ObjectModelLinkedForm = 3006,

  // Process Flow Types
  // 4001 reserved for ProcessFlow if ever needed.
  ProcessFlowVariable = 4002,
  ProcessFlowInitiatorFirstName = 4003,
  ProcessFlowInitiatorLastName = 4004,
  ProcessFlowInitiatorEmail = 4005,
  ProcessFlowTriggerTime = 4006,
  ProcessFlowTitle = 4007,

  ApiConnection = 5001,
  ApiEndpoint = 5002,
  ApiMessageType = 5003,
  DynamicInput = 5004,
  ApiHeader = 5005,
  ApiURLParameter = 5006,
  Email = 6001,

  // Certificate Types
  Certificate = 7001,
  CertificateDynamicInput = 7002,
}

export const ReferenceNodeTextDestinationTypes: ReferenceNodeType[] = [
  ReferenceNodeType.FormElement,
  ReferenceNodeType.ObjectModelProperty
]

export const ReferenceNodeFileDestinationTypes: ReferenceNodeType[] = [
  ReferenceNodeType.FormElement,
  ReferenceNodeType.ObjectModelProperty
]

/**
 * How to map a ReferenceNodeType to a GenericType
 */
export const ReferenceNodeGenericTypeMap: { [key in ReferenceNodeType]: GenericType } = {
  [ReferenceNodeType.OriginalSubmitter]: ModelType.Object, // should these be User instead?
  [ReferenceNodeType.RecordHolder]: ModelType.Object,
  [ReferenceNodeType.AllCompleters]: ModelType.Object,
  [ReferenceNodeType.StepCompleter]: ModelType.Object,
  [ReferenceNodeType.FormSubmissionDate]: ModelType.DateTime,
  [ReferenceNodeType.FormSubmissionID]: ModelType.Text,
  [ReferenceNodeType.Form]: ModelType.Object,
  [ReferenceNodeType.FormElement]: ModelType.Object,
  [ReferenceNodeType.WorkflowStep]: ModelType.Object,
  [ReferenceNodeType.FormSection]: ModelType.Object,
  [ReferenceNodeType.WorkflowStepAction]: ModelType.Object,
  [ReferenceNodeType.FormPaymentsTotalCost]: ModelType.Text,
  [ReferenceNodeType.FormPaymentsType]: ModelType.Text,
  [ReferenceNodeType.FormPaymentsDate]: ModelType.DateTime,
  [ReferenceNodeType.FormPaymentsLineItem]: ModelType.Object,
  [ReferenceNodeType.WorkflowStepStart]: ModelType.DateTime,
  [ReferenceNodeType.WorkflowStepEnd]: ModelType.DateTime,
  [ReferenceNodeType.WorkflowGeneratedCert]: ModelType.File,
  [ReferenceNodeType.ObjectModel]: ModelType.Object,
  [ReferenceNodeType.ObjectModelProperty]: ModelType.Object,
  [ReferenceNodeType.ObjectModelRelation]: ModelType.Object,
  [ReferenceNodeType.AccountRelationMetadata]: ModelType.Text,
  [ReferenceNodeType.ObjectModelRecordMetadata]: ModelType.Text,
  [ReferenceNodeType.ObjectModelLinkedForm]: ModelType.Object,
  [ReferenceNodeType.ProcessFlowVariable]: ModelType.Object,
  [ReferenceNodeType.ApiConnection]: ModelType.Object,
  [ReferenceNodeType.ApiEndpoint]: ModelType.Object,
  [ReferenceNodeType.ApiMessageType]: ModelType.Text,
  [ReferenceNodeType.DynamicInput]: ModelType.Object,
  [ReferenceNodeType.ApiHeader]: ModelType.Text,
  [ReferenceNodeType.ApiURLParameter]: ModelType.Text,
  [ReferenceNodeType.Email]: ModelType.Text,
  [ReferenceNodeType.ProcessFlowInitiatorFirstName]: ModelType.Text,
  [ReferenceNodeType.ProcessFlowInitiatorLastName]: ModelType.Text,
  [ReferenceNodeType.ProcessFlowInitiatorEmail]: ModelType.Text,
  [ReferenceNodeType.ProcessFlowTriggerTime]: ModelType.DateTime,
  [ReferenceNodeType.ProcessFlowTitle]: ModelType.Text,
  [ReferenceNodeType.Certificate]: ModelType.Object,
  [ReferenceNodeType.CertificateDynamicInput]: ModelType.Object,
} as const

/**
 * How to map a ReferenceNodeType to a GenericType
 */
export const ReferenceNodeModelTypeMap: { [key in ReferenceNodeType]: ModelType } = {
  ...ReferenceNodeGenericTypeMap,
  [ReferenceNodeType.Email]: ModelType.Email,
  [ReferenceNodeType.ProcessFlowInitiatorEmail]: ModelType.Email,
} as const